import { render } from "./SupportLayout.vue?vue&type=template&id=4ea5d4fb"
import script from "./SupportLayout.vue?vue&type=script&lang=js"
export * from "./SupportLayout.vue?vue&type=script&lang=js"

import exportComponent from "/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__